






























































































































































































import axios from "axios";
import DiscountSettings from '../components/rewards/DiscountSettings.vue'
import RewardBlock from '../components/rewards/RewardBlock.vue'
import FreeGift from '../components/rewards/FreeGift.vue'
import FreeShipping from '../components/rewards/FreeShipping.vue'
import Skeleton from '../components/Skeleton.vue'

//const devLink = "http://localhost:5000";
const devLink = "";

export default {
  name: 'Index',
  components: {
    DiscountSettings,
    FreeGift,
    FreeShipping,
    RewardBlock,
    Skeleton
  },
  middleware: 'authenticated',
  props: ['storeDomain','storeName'],
  data () {
    return {
      currencies: [],
      currencySymbol: "$",
      currencyRewards: {},
      defaultCurrency: "",
      enabledCurrencies: [],
      discountType: null,
      errors: [],
      errorTypes: {
        gift: false,
        rewards: false
      },
      gift: {
        enable: false,
        requirement: null,
        productId: "",
        variantId: "",
        handle: "",
        title: "",
        image: "",
        variantTitle: "",
      },
      loading: true,
      original: {},
      productFilters: {
        afterCursor: "",
        beforeCursor: "",
        prevPage: "",
        nextPage: "",
        search: "",
        sortBy: "TITLE",
      },
      requirementType: null,
      rewards: [{
        discountValue: null,
        discountRequirement: null,
        enable: false,
      },
      {
        discountValue: null,
        discountRequirement: null,
        enable: false,
      },
      {
        discountValue: null,
        discountRequirement: null,
        enable: false,
      },
      {
        discountValue: null,
        discountRequirement: null,
        enable: false,
      }],
      saving: false,
      saved: false,
      selectedCurrency: "",
      settings: [],
      showSaveBar: false,
      shipping: {
        condition: "",
        countries: "",
        enable: false,
        tier: 1,
        title: "Worldwide",
        zone: ""
      },
      productList: [],
      productListOriginal: [],
    }
  },
  methods: {
    onGiftUpdate(gift) {
      this.gift = {
        enable: gift.enable,
        productId: gift.productId,
        variantId: gift.variantId,
        handle: gift.handle !== undefined ? gift.handle : "",
        title: gift.title,
        image: gift.image,
        variantTitle: gift.variantTitle,
        requirement: gift.requirement
      }
    },
    onShippingUpdate(shipping) {
      this.shipping = {
        condition: shipping.condition,
        countries: shipping.countries,
        enable: Boolean(shipping.enable),
        tier: parseInt(shipping.tier),
        title: shipping.title,
        zone: shipping.zone
      }
    },
    switchCurrency() {
      this.selectedCurrency === 'TRY' ? this.currencySymbol = "₺" :
      this.selectedCurrency === 'EUR' ? this.currencySymbol = "€" :
      this.selectedCurrency === 'INR' ? this.currencySymbol = "₹" :
      this.selectedCurrency === 'RUB' ? this.currencySymbol = "₽" :
      this.selectedCurrency === 'THB' ? this.currencySymbol = "฿" :
      this.selectedCurrency === 'VND' ? this.currencySymbol = "₫" :
      this.selectedCurrency === 'KRW' ? this.currencySymbol = "₩" :
      this.selectedCurrency === 'CNY' || this.selectedCurrency === 'JPY' ? this.currencySymbol = "¥" :
      this.selectedCurrency === 'GBP' ? this.currencySymbol = "£" : "$";

      if(this.selectedCurrency !== "") {
        this.loadRewardsData(this.selectedCurrency);
      } else {
        this.selectedCurrency = this.defaultCurrency;
        this.loadRewardsData(this.defaultCurrency);
      }
    },
    async loadProducts(action) {
      try {
        await axios.post(
        devLink + "/api/starter/products",
        {
          shopDomain: this.storeDomain,
          action: action,
          productCount: 10,
          aCursor: this.productFilters.afterCursor,
          bCursor: this.productFilters.beforeCursor,
          prevPage: this.productFilters.prevPage,
          nextPage: this.productFilters.nextPage,
          search: this.productFilters.search,
          sortBy: this.productFilters.sortBy
        }).then((response) => {
          const productList = []
          const products = response.data.data.results.products.edges
          this.productFilters.prevPage = response.data.data.results.products.pageInfo.hasPreviousPage;
          this.productFilters.nextPage = response.data.data.results.products.pageInfo.hasNextPage;

          for (var i = 0; i < products.length; i++) {
            const product = products[i].node
            this.productFilters.beforeCursor = products[0].cursor;
            this.productFilters.afterCursor = products[Math.abs(products.length - 1)].cursor;

            const productTitle = product.title
            const productId = (product.id).replace('gid://shopify/Product/', '')
            var variants = []

            for (var v = 0; v < product.variants.edges.length; v++) {
              const variant = product.variants.edges[v].node
              const variantData = {
                id: (variant.id).replace('gid://shopify/ProductVariant/', ''),
                title: variant.title,
                image: variant.image !== null ? variant.image.src : ""
              }
              variants.push(variantData);
            }

            productList.push({
              id: productId,
              image: product.featuredImage !== null ? product.featuredImage.src : '',
              title: productTitle,
              selectedVariant: 0,
              handle: product.handle,
              variants: variants
            });

          }
          this.productList = productList
          this.productListOriginal = productList
        });
      } catch (e) {
        console.log(e);
      }
    },
    async loadRewardsData(currency) {
      try {
        this.loading = true
        await axios.post(
            devLink + "/api/store",
            {
              shopDomain: this.storeDomain
            }).then((response) => {
          this.currencies = response.data.data.results.paymentSettings.enabledPresentmentCurrencies;
          this.defaultCurrency = response.data.data.results.currencyCode;
          if(!currency) {
            this.selectedCurrency = this.defaultCurrency;
          }
          this.selectedCurrency === 'TRY' ? this.currencySymbol = "₺" :
          this.selectedCurrency === 'EUR' ? this.currencySymbol = "€" :
          this.selectedCurrency === 'INR' ? this.currencySymbol = "₹" :
          this.selectedCurrency === 'RUB' ? this.currencySymbol = "₽" :
          this.selectedCurrency === 'THB' ? this.currencySymbol = "฿" :
          this.selectedCurrency === 'VND' ? this.currencySymbol = "₫" :
          this.selectedCurrency === 'GBP' ? this.currencySymbol = "£" : "$"
        });


        await axios.post(
          devLink + "/api/rewards",
          {
            shopDomain: this.storeDomain
          }).then((response) => {
          const settings = response.data.data.results.settings.data
          var discounts = settings.discounts

          if (currency && currency !== this.defaultCurrency && settings.discounts.currencies !== undefined && settings.discounts.currencies[currency] !== undefined) {
            discounts = settings.discounts.currencies[currency];
          }

          if (settings.discounts.currencies === undefined) {
            settings.discounts.currencies = {};
          }

          if (currency && currency !== this.defaultCurrency && settings.discounts.currencies[currency] === undefined) {
            discounts = {
              discountType: "percentage",
              requirementType: "minimum_purchase_amount",
              gift: {
                enable: false,
                requirement: 100,
                productId: 0,
                variantId: 0,
                handle: "",
                title: "",
                image: "",
                variantTitle: "",
              },
              tiers: [{
                discountValue: 0,
                discountRequirement: 0,
                enable: false,
              },
              {
                discountValue: 0,
                discountRequirement: 0,
                enable: false,
              },
              {
                discountValue: 0,
                discountRequirement: 0,
                enable: false,
              },
              {
                discountValue: 0,
                discountRequirement: 0,
                enable: false,
              }],
              shipping: {
                condition: "",
                countries: "",
                enable: false,
                tier: 1,
                title: "Worldwide",
                zone: ""
              }
            }
          }

         // Insert Data
          this.discountType = discounts.discountType
          this.requirementType = discounts.requirementType
          this.rewards = discounts.tiers
          this.gift = discounts.gift
          this.shipping = discounts.shipping

          this.currencyRewards = settings.discounts.currencies !== undefined ? settings.discounts.currencies : {};

          this.original.discountType = discounts.discountType
          this.original.requirementType = discounts.requirementType
          this.original.rewards = discounts.tiers
          this.original.gift = discounts.gift
          this.original.shipping = discounts.shipping

          if (settings.discounts.currencies !== undefined) {
            this.enabledCurrencies = Object.keys(settings.discounts.currencies);
            this.enabledCurrencies.unshift(this.defaultCurrency);
            for ( const property in this.enabledCurrencies) {
              for ( const currency in this.currencies) {
                if(currency !== undefined && this.currencies[currency] == this.enabledCurrencies[property]) {
                  delete this.currencies[currency];
                }
              }
            }
          } else {
            this.enabledCurrencies = [this.defaultCurrency];
          }

          this.watch()
          this.loading = false
          this.showSaveBar = false
        });
      } catch (e) {
        console.log(e);
      }
    },
    discard() {
      this.discountType = this.original.discountType
      this.requirementType = this.original.requirementType
      this.rewards = this.original.rewards
      this.gift = this.original.gift
      this.shipping = this.original.shipping
      this.showSaveBar = false
      this.watch()
    },
    watch() {
      const unwatch = this.$watch(vm => [vm.discountType, vm.requirementType, vm.rewards, vm.gift, vm.shipping], val => {
        this.showSaveBar = true
      }, {
        immediate: false,
        deep: true
      })
    },
    async saveData() {
      this.errors = [];

      if (this.shipping.enable) {
        if (this.shipping.tier === 1) {
          this.rewards[0].discountValue = 0;
        }
        if (this.shipping.tier === 2) {
          this.rewards[1].discountValue = this.rewards[0].discountValue;
        }
        if (this.shipping.tier === 3) {
          this.rewards[2].discountValue = this.rewards[1].discountValue;
        }
        if (this.shipping.tier === 4) {
          this.rewards[3].discountValue = this.rewards[2].discountValue;
        }
      }

      if(this.gift.enable && (this.gift.productId === 0 || this.gift.variantId === 0)) {
        this.errors.push("You must select a product for the free gift.");
      }

      if(this.gift.enable && this.gift.requirement === "") {
        this.errors.push("You must enter a requirement for the free gift.");
      }

      if(this.rewards[0].enable && (this.rewards[0].discountValue === '' || this.rewards[0].discountRequirement === '')) {
        this.errors.push("Reward 1 must have a value.");
      }

      if(this.rewards[1].enable && ((Number(this.rewards[1].discountValue) < Number(this.rewards[0].discountValue)) || (Number(this.rewards[1].discountRequirement) < Number(this.rewards[0].discountRequirement)) || (this.rewards[1].discountValue === '' || this.rewards[1].discountRequirement === ''))) {
        this.errors.push("Reward 2 must be greater than Reward 1.");
      }

      if(this.rewards[2].enable && ((Number(this.rewards[2].discountValue) < Number(this.rewards[1].discountValue)) || (Number(this.rewards[2].discountRequirement) < Number(this.rewards[1].discountRequirement)) || (this.rewards[2].discountValue === '' || this.rewards[2].discountRequirement === ''))) {
        this.errors.push("Reward 3 must be greater than Reward 2.");
      }

      if(this.rewards[3].enable && ((Number(this.rewards[3].discountValue) < Number(this.rewards[2].discountValue)) || (Number(this.rewards[3].discountRequirement) < Number(this.rewards[2].discountRequirement)) || (this.rewards[3].discountValue === '' || this.rewards[3].discountRequirement === ''))) {
        this.errors.push("Reward 4 must be greater than Reward 3.");
      }

      if(this.errors.length > 0) {
        window.scrollTo(0, 0);
        return false;
      }

      this.saving = true

      try {
        const currentPage = "rewards"

        var data = {
          discountType: this.discountType,
          gift: this.gift,
          requirementType: this.requirementType,
          tiers: this.rewards,
          shipping: this.shipping
        };

        if (this.defaultCurrency !== this.selectedCurrency) {
          if(this.currencyRewards[this.selectedCurrency] === undefined) {
            this.enabledCurrencies.push(this.selectedCurrency);
          }
          for ( const property in this.enabledCurrencies) {
            for ( const currency in this.currencies) {
              if (this.currencies[currency] == this.enabledCurrencies[property]) {
                delete this.currencies[currency];
              }
            }
          }
          this.currencyRewards[this.selectedCurrency] = data;
        }

        await axios.post(
          devLink + "/api/save",
          {
            shopDomain: this.storeDomain,
            page: currentPage,
            uid: this.$fire.auth.currentUser.uid,
            data: this.defaultCurrency === this.selectedCurrency ? data : { currencies: this.currencyRewards },
            responseType: "json",
          }).then((response) => {
            setTimeout(()=>{
              this.saving = false
              this.showSaveBar = false
              this.saved = true
            }, 500);
          });
      } catch(e) {
        console.log(e);
      }
    },
  },
  mounted () {
    this.loadRewardsData()
  }
}
